import { useMediaQuery, useTheme } from "@mui/material";
import { FC, useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { getPropostaDetalhada } from "src/store/global.store";
import { Formater, TypeRecords } from "src/framework/commons/Formater";
import PrintIcon from "@mui/icons-material/Print";
import { useReactToPrint } from "react-to-print";
import './styles.css';
import PrazoEntregaProdutos, { PrazoEntregaProdutosContinuacao } from "./PrazoEntregaProdutos";
import OrdemServicoManutencaoGarantias from "./OrdemServicoManutencaoGarantias";
import ConsidferacoesAlteracoesObrigacoes from "./ConsidferacoesAlteracoesObrigacoes";
import CondicoesPagamento from "./CondicoesPagamento";
import Investimento from "./Investimento";
import PaginaLogoIntelbras from "./PaginaLogoIntelbras";
import TermosAceiteProposta from "./TermosAceiteProposta";
import ConsidferacoesAlteracoesObrigacoesContinuacao from "./ConsidferacoesAlteracoesObrigacoesContinuacao";
import TabelaRetornoInvestimento from "./TabelaRetornoInvestimento";
import Payback from "./Payback";
import PaybackConsumo from "./PaybackConsumo";
import Financiamento from "./Financiamento";
import { parsePhone } from "src/framework/commons/masks";
import { propostasLoading$ } from "src/framework/store/ApiEvents";
import { isFirefox, isMobile } from "src/components/projetos/utils/deviceUtils";

type RouteParams = {
    hash: string;
};

interface PropostaDatalhadaContentProps {
    data: any
}

const resolveImage = (image: string) => {
    return new Promise((resolve, reject) => {
        const loadImg = new Image()
        loadImg.src = image
        loadImg.onload = () => resolve(image)
        loadImg.onerror = err => reject(err)
    })
}

export const PropostaDatalhada = () => {
    const history = useHistory<{ sValores?: boolean; }>();

    const [loadingDataProposta, setLoadingDataProposta] = useState(false)
    const [loadingImages, setLoadingImages] = useState(false)
    const { hash } = useParams<RouteParams>();
    const [data, setData] = useState<any>();

    useEffect(() => {
        const loadProposta = async () => {
            setLoadingDataProposta(true)
            const propostaDetalhada = await getPropostaDetalhada(hash);

            if (propostaDetalhada?.projeto) {
                setData(propostaDetalhada);
                //addClassPage();
            }

            setLoadingDataProposta(false)

            return propostaDetalhada;
        }

        if (hash) {
            loadProposta();
        }
    }, [hash, history.location]);

    useEffect(()=>{
        propostasLoading$.next(loadingImages || loadingDataProposta)
    },[loadingImages, loadingDataProposta])

    useEffect(() => {
        if (!data || Object.values(data?.imagens || {}).length === 0) return;

        setLoadingImages(true)

        Promise
            .all(Object.values(data.imagens).map((image: any) => resolveImage(image)))
            .finally(() => setLoadingImages(false))
            .catch(err => {})
    }, [data])

    useEffect(() => {
        document.body.classList.add('proposta-web');
    }, []);

    if (!data || loadingImages || loadingDataProposta) return <></>

    return (
        <PropostaDatalhadaContent data={data} />
    )
}

const PropostaDatalhadaContent: FC<PropostaDatalhadaContentProps> = ({ data }) => {
    const componentRef = useRef<HTMLDivElement | null>(null);

    const [capaIsLoading, setCapaIsLoading] = useState(true)
    
    const theme = useTheme();
    const isTabletOrSmaller = useMediaQuery(theme.breakpoints.down('md'));

    const componenteFiname = data?.projeto?.componentes_finame?.find((cf: any) => cf)?.codigo_finame || "";
    const revendaOuDistribuidor = data?.projeto?.fantasia_revenda ? 'Revenda' : 'Distribuidor';
    const revendaOuDistribuidorNomeFantasia = data?.projeto?.fantasia_revenda || data?.projeto?.fantasia_distribuidor || "";
    const revendaOuDistribuidorPhone = parsePhone(data?.projeto?.whatsapp_proposta_revenda || data?.projeto?.whatsapp_proposta_revenda || data?.projeto?.telefone_revenda || data?.projeto?.telefone_distribuidor || "") || "";
    const geracao_total = data?.dadosRetornoPayback?.geracao_total || 0;
    const valor_servico = data?.projeto?.valor_servico || 0;

    const logoRevenda = data?.projeto?.revenda_logo_path ? data.projeto.revenda_logo_path : "";
    let rangePayback = "";
    let consumo_total = 0;

    let contadorPagina = 6;

    const handlePrint = useReactToPrint({
        contentRef: componentRef,
        preserveAfterPrint: true,
        documentTitle: `Proposta_${data?.projeto?.codigo_venda}`,
        pageStyle: `
            @page {
                size: A4;
                margin: 12mm 0;
            }
            body {
                margin: 0;
                padding: 0;  
                background: white;
                -webkit-print-color-adjust: exact;
            }

            *, html, body {
                font-size: 12pt !important;
                font-family: var(--intelbras-font)
            }

            .page td {
                font-family: var(--intelbras-font) !important
            }
        `
    });

    const handlePaginacao = () => {
        const pagina = contadorPagina;
        contadorPagina++;

        return pagina;
    }

    const calculaRange = (dados_retorno: any) => {
        const positiveNumbers = dados_retorno.filter((item: any) => Number(item["retorno_investimento"] >= 0))
        const negativeNumbers = dados_retorno.filter((item: any) => Number(item["retorno_investimento"] < 0))
        const range2 = positiveNumbers.shift();
        const range1 = negativeNumbers.pop();
        const range1Ano = range1?.ano;
        const range2Ano = range2?.ano;
        if (!range1Ano === undefined || !range2Ano === undefined) return ''
        if (range2Ano === 0) return `${1} Ano`
        if (range1Ano === range2Ano) return `${range1Ano} Ano(s)`
        return `Entre ${range1Ano} e ${range2Ano} Ano(s)`
    }

    if (data?.dadosRetornoPayback?.consumo) {
        const consumo = data?.dadosRetornoPayback?.consumo;
        for (const idx in consumo) {
            if (consumo.hasOwnProperty(idx)) {
                consumo_total += consumo[idx];
            }
        }
    }

    if (data?.dadosRetornoPayback?.dados) {
        rangePayback = calculaRange(data?.dadosRetornoPayback?.dados);
    }

    return (
        <>
            <div style={{ opacity: capaIsLoading ? '0' : '1' }} className='root-detalhada'>
                <div className={`page-container ${(isFirefox() || isMobile()) ? "page-firefox" : ""}`} ref={componentRef} >
                    <div className="page" style={{ position: "relative" }}>
                        <img src={data.imagens.capa} alt="" className="image-capa" loading="eager" onLoad={() => setCapaIsLoading(false)} />
                        {/*
                        <table className="table-home">
                            <tr>
                                <td className="table-home-row">
                                    <div className="grid-header grid-item-nome-cliente-header">
                                        Cliente:
                                    </div>
                                    <div className="grid-coluna grid-item-nome-cliente">
                                        {data.projeto?.cliente_proposta}
                                    </div>
                                </td>
                                <td className="table-home-row">
                                    <div className="grid-header grid-item-endereco-header">
                                        Endereço de Instalação:
                                    </div>
                                    <div className="grid-coluna grid-item-endereco">
                                        {data.projeto.endereco_logradouro}, {data.projeto.endereco_numero} - {data.projeto.endereco_bairro} - {data.projeto.endereco_cidade_nome}/{data.projeto.endereco_uf} - CEP: {data.projeto?.endereco_cep?.replace(/\D/g, '').replace(/(\d{5})(\d)/, '$1-$2').replace(/(-\d{3})\d+?$/, '$1')}
                                    </div>
                                </td>

                                <td className="table-home-row">

                                </td>
                            </tr>
                            <tr>
                                <td className="table-home-row">
                                    <div className="grid-header grid-item-numero-proposta-header">
                                        Nº da Proposta:
                                    </div>
                                    <div className="grid-coluna grid-item-numero-proposta">
                                        {data.projeto?.codigo_venda}
                                        {componenteFiname ? (
                                            <div>{componenteFiname}</div>
                                        ) : null}
                                        <div className="grid-coluna-finame"></div>
                                    </div>
                                </td>
                                <td className="table-home-row">
                                    <div className="grid-header grid-item-validade-proposta-header">
                                        Validade da proposta:
                                    </div>
                                    <div className="grid-coluna grid-item-validade-proposta">
                                        {Formater.toString(data.projeto?.data_expiracao, TypeRecords.DATE)}
                                    </div>
                                </td>
                                <td className="table-home-row">
                                    <div className="grid-header grid-item-potencia-gerador-header">
                                        Potência do Gerador:
                                    </div>
                                    <div className="grid-coluna grid-item-potencia-gerador">
                                        {data.projeto?.potencia ? data.projeto?.potencia.toLocaleString('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 }) : 0} kWp
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td className="table-home-row">
                                    <div className="grid-item-logo-revenda">
                                        {logoRevenda ? <img src={logoRevenda} alt="" className="logo-intelbras" /> : null}
                                    </div>
                                </td>
                                <td className="table-home-row">
                                    <div className=" grid-item-revenda-header">
                                        <div className="grid-header">{revendaOuDistribuidor}</div>
                                        <div className="grid-coluna" style={{ marginBottom: "10pt" }}>{revendaOuDistribuidorNomeFantasia}</div>
                                        <div className="grid-coluna" style={{ marginBottom: "0pt" }}>{revendaOuDistribuidorPhone}</div>
                                    </div>
                                </td>

                                <td className="table-home-row">
                                    <div className="grid-item-logo-intelbras">
                                        <img src={data.imagens.logoIntelBras} alt="" className="logo-intelbras" />
                                    </div>
                                </td>
                            </tr>


                        </table>

                        */}
                        
                        <div className="grid-dados-projeto">
                            <div className="grid-header grid-item-nome-cliente-header">
                                Cliente:
                            </div>
                            <div className="grid-header grid-item-endereco-header">
                                Endereço de Instalação:
                            </div>
                            <div className="grid-coluna grid-item-nome-cliente">
                                {data.projeto?.cliente_proposta}
                            </div>
                            <div className="grid-coluna grid-item-endereco">
                                {data.projeto.endereco_logradouro}, {data.projeto.endereco_numero} - {data.projeto.endereco_bairro} - {data.projeto.endereco_cidade_nome}/{data.projeto.endereco_uf} - CEP: {data.projeto?.endereco_cep?.replace(/\D/g, '').replace(/(\d{5})(\d)/, '$1-$2').replace(/(-\d{3})\d+?$/, '$1')}
                            </div>
                            <div className="grid-coluna">

                            </div>
                            <div className="grid-header grid-item-numero-proposta-header">
                                Nº da Proposta:
                            </div>
                            <div className="grid-header grid-item-validade-proposta-header">
                                Validade da proposta:
                            </div>
                            <div className="grid-header grid-item-potencia-gerador-header">
                                Potência do Gerador:
                            </div>
                            <div className="grid-coluna grid-item-numero-proposta">
                                {data.projeto?.codigo_venda}
                                {componenteFiname ? (
                                    <div>{componenteFiname}</div>
                                ) : null}
                                <div className="grid-coluna-finame"></div>
                            </div>
                            <div className="grid-coluna grid-item-validade-proposta">
                                {Formater.toString(data.projeto?.data_expiracao, TypeRecords.DATE)}
                            </div>
                            <div className="grid-coluna grid-item-potencia-gerador">
                                {data.projeto?.potencia ? data.projeto?.potencia.toLocaleString('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 }) : 0} kWp
                            </div>
                            <div className="grid-item-logo-revenda">
                                {logoRevenda ? <img src={logoRevenda} alt="" className="logo-intelbras" /> : null}
                            </div>
                            <div className=" grid-item-revenda-header">
                                <div className="grid-header">{revendaOuDistribuidor}</div>
                                <div className="grid-coluna" style={{ marginBottom: "10pt" }}>{revendaOuDistribuidorNomeFantasia}</div>
                                <div className="grid-coluna" style={{ marginBottom: "0pt" }}>{revendaOuDistribuidorPhone}</div>
                            </div>
                            <div className="grid-item-logo-intelbras">
                                <img src={data.imagens.logoIntelBras} alt="" className="logo-intelbras" />
                            </div>

                        </div>
                    </div>

                    <div className="page-break" />

                    <div className="page print-image page-image-ajustada">
                        <img src={data.imagens.sempreProxima} alt="" className="image-sempre-proxima" />
                    </div>

                    <div className="page-break" />

                    <div className="page print-image page-image-ajustada">
                        <img src={data.imagens.energiaSolarNaoETudoIgual} alt="" className="energia-solar-nao-e-tudo-igual" />
                    </div>

                    <div className="page-break" />

                    <div className="page print-image page-image-ajustada">
                        <img src={data.imagens.energiaSolarNaoETudoIgual2} alt="" className="energia-solar-nao-e-tudo-igual2" />
                    </div>

                    <div className="page-break" />

                    <div className="page print-image">
                        <img src={data.imagens.entendaComoFunciona} alt="" className="entenda-como-funciona" />
                    </div>

                    {data.graficoPayback && data.graficoConsumo && data?.gerarGraficoConsumo ? <>
                        <PaginaLogoIntelbras logo={data.imagens.logo} pagina={handlePaginacao()}>
                            <PaybackConsumo graficoConsumo={data.graficoConsumo} geracao_total={geracao_total} consumo_total={consumo_total} />
                        </PaginaLogoIntelbras>
                    </> : null}

                    {data.graficoPayback && data.graficoConsumo ? <>
                        <PaginaLogoIntelbras logo={data.imagens.logo} pagina={handlePaginacao()}>
                            <Payback graficoPayback={data.graficoPayback} graficoConsumo={data.graficoConsumo} geracao_total={geracao_total} consumo_total={consumo_total} valor_servico={valor_servico} rangePayback={rangePayback} gerarGradicoConsumo={data?.gerarGraficoConsumo} />

                            {data.dadosRetornoPayback ? <TabelaRetornoInvestimento dadosRetorno={data.dadosRetornoPayback?.dados || []} rangePayback={rangePayback} /> : null}
                        </PaginaLogoIntelbras>
                    </> : null}

                    <PaginaLogoIntelbras logo={data.imagens.logo} pagina={handlePaginacao()}>
                        <PrazoEntregaProdutos />

                    </PaginaLogoIntelbras>

                    <PaginaLogoIntelbras logo={data.imagens.logo} pagina={handlePaginacao()}>
                        <PrazoEntregaProdutosContinuacao />
                    </PaginaLogoIntelbras>

                    <PaginaLogoIntelbras logo={data.imagens.logo} pagina={handlePaginacao()} addBottom={true}>
                        <OrdemServicoManutencaoGarantias informacoesGarantia={data?.informacoesGarantia || []} temServico={data?.projeto?.valor_servico > 0} componentes={data.componentes} segmento_projeto={data?.projeto?.segmento?.includes("on") ? "on" : "off"}/>
                    </PaginaLogoIntelbras>

                    <PaginaLogoIntelbras logo={data.imagens.logo} pagina={handlePaginacao()}>
                        <ConsidferacoesAlteracoesObrigacoes />
                    </PaginaLogoIntelbras>

                    <PaginaLogoIntelbras logo={data.imagens.logo} pagina={handlePaginacao()}>
                        <ConsidferacoesAlteracoesObrigacoesContinuacao />
                    </PaginaLogoIntelbras>

                    <PaginaLogoIntelbras logo={data.imagens.logo} pagina={handlePaginacao()}>
                        <Investimento componenteFiname={componenteFiname} data={data} />
                    </PaginaLogoIntelbras>

                    <PaginaLogoIntelbras logo={data.imagens.logo} pagina={handlePaginacao()}>
                        <CondicoesPagamento dadosParcela={data.valorParcelasCartao} dados={data.projeto} />
                    </PaginaLogoIntelbras>
                    
                    {data?.projeto?.simulacao_financiamento?.simulacoes?.length ? <>
                        <PaginaLogoIntelbras logo={data.imagens.logo} pagina={handlePaginacao()}>
                            <Financiamento dados={data} />
                        </PaginaLogoIntelbras>
                    </> : null}

                    <PaginaLogoIntelbras logo={data.imagens.logo} pagina={handlePaginacao()}>
                        <TermosAceiteProposta data={data} />
                    </PaginaLogoIntelbras>

                    <div className="page-break" />

                    <div className="page print-image page-image-ajustada">
                        <img src={data.imagens.intelbrasInaugura} alt="" className="intelbras-inaugura" />
                    </div>
                </div>

                <button className="print-button" onClick={handlePrint}>
                    {!isTabletOrSmaller
                        ? (<>IMPRIMIR <br /> PROPOSTA</>)
                        : (<PrintIcon style={{ fontSize: 33 }} />)
                    }
                </button>
            </div>
        </>
    );
}

export default PropostaDatalhada;